import { render, staticRenderFns } from "./studyList.vue?vue&type=template&id=60c9ac06&scoped=true&"
import script from "./studyList.vue?vue&type=script&lang=js&"
export * from "./studyList.vue?vue&type=script&lang=js&"
import style0 from "./studyList.vue?vue&type=style&index=0&id=60c9ac06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c9ac06",
  null
  
)

export default component.exports